/**
 * KPICard - reusable kpi tile for dashboards.
 */
import { Card } from "@/components/ui/card";

export default function KPICard({ icon: Icon, label, value, hint, accent = "#A78BFA", testid }) {
    return (
        <Card
            className="glass-card p-5 rounded-2xl border-white/10"
            data-testid={testid}
        >
            <div className="flex items-start justify-between">
                <div className="flex flex-col gap-2">
                    <span className="text-xs font-medium text-muted-foreground">{label}</span>
                    <span className="font-display text-3xl font-semibold tracking-tight">{value}</span>
                    {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
                </div>
                {Icon && (
                    <div
                        className="h-10 w-10 rounded-xl grid place-items-center"
                        style={{ backgroundColor: `${accent}20`, color: accent }}
                    >
                        <Icon className="h-5 w-5" />
                    </div>
                )}
            </div>
        </Card>
    );
}
